import React, { useEffect, useRef } from "react";

const $ = window.$;

export default function RealtimeMarketTable({ tableData }) {
  const tableEl = useRef();

  useEffect(() => {
    const $el = $(tableEl.current);
    const table = $el.DataTable({
      dom: 'lf<"headertitle">tB<"footertitle">',
      data: tableData,
      keys: true,
      order: [[8, "desc"]],
      buttons: [{ extend: "colvis", text: "Select Columns", collectionLayout: "fixed two-column" }],
      columns: [
        { title: "Domain", data: "landing_domain", visible: false },
        { title: "Source-Medium", data: "value" },
        { title: "Total Visitors", data: "total", name: "totalvisitors" },
        {
          title: "Total Trend",
          data: "sparktotal",
          name: "totalvisitortrend",
          render: function (row, data) {
            return '<span class="spark">' + row + "</span>";
          },
        },
        { title: "New Visitors", name: "newvisitors", data: "new" },
        {
          title: "New Trend",
          data: "sparknew",
          name: "newvisitortrend",
          render: function (row, data) {
            return '<span class="spark">' + row + "</span>";
          },
        },
        { title: "Returning Visitors", name: "returningvisitors", data: "returning" },
        {
          title: "Returning Trend",
          data: "sparkreturning",
          name: "returningvisitortrend",
          render: function (row, data) {
            return '<span class="spark">' + row + "</span>";
          },
        },
        { title: "Total Calls", name: "totalcalls", data: "calls" },
        {
          title: "Call Trend",
          data: "sparkcalls",
          name: "calltrend",
          render: function (row, data) {
            return '<span class="spark">' + row + "</span>";
          },
        },
        { title: "Total Chats", name: "totalchats", data: "chats" },
        {
          title: "Chat Trend",
          data: "sparkchats",
          name: "chattrend",
          render: function (row, data) {
            return '<span class="spark">' + row + "</span>";
          },
        },
        { title: "Total Leads", name: "totalleads", data: "leads" },
        {
          title: "Lead Trend",
          name: "leadtrend",
          data: "sparkleads",
          render: function (row, data) {
            return '<span class="spark">' + row + "</span>";
          },
        },
      ],
      columnDefs: [{ className: "table_cell_centered_text", targets: "_all" }],
      colReorder: false,
      stateSave: false,
      stateSaveCallback: function (oSettings, oData) {
        localStorage.setItem("DataTables-AI-RealTimeMarketDash", JSON.stringify(oData));
      },
      stateLoadCallback: function (oSettings) {
        return JSON.parse(localStorage.getItem("DataTables-AI-RealTimeMarketDash"));
      },
      lengthMenu: [
        [5, 10, 25, 50, 100, -1],
        [5, 10, 25, 50, 100, "All"],
      ],
      drawCallback: function (oSettings, json) {
        $(".spark:not(:has(canvas))").sparkline("html", {
          type: "line",
          width: "80",
          height: "30",
          lineColor: "#0066cc",
          lineWidth: 1,
          spotRadius: 2.5,
          fillColor: "#c8cbce",
          minSpotColor: "red",
          maxSpotColor: "green",
          spotColor: true,
        });
      },
      footerCallback: function (row, data, start, end, display) {
        var api = this.api();
        // Remove the formatting to get integer data for summation
        var intVal = function (i) {
          return typeof i === "string" ? i.replace(/[$,]/g, "") * 1 : typeof i === "number" ? i : 0;
        };
        // Total over this page
        var pageTotal2 = api
          .column("totalvisitors:name", { page: "current", order: "index" })
          .data()
          .reduce(function (a, b) {
            return intVal(a) + intVal(b);
          }, 0);
        // Total over this page
        var pageTotal4 = api
          .column("newvisitors:name", { page: "current", order: "current" })
          .data()
          .reduce(function (a, b) {
            return intVal(a) + intVal(b);
          }, 0);
        // Total over this page
        var pageTotal6 = api
          .column("returningvisitors:name", { page: "current", order: "current" })
          .data()
          .reduce(function (a, b) {
            return intVal(a) + intVal(b);
          }, 0);
        // Total over this page
        var pageTotal8 = api
          .column("totalcalls:name", { page: "current", order: "current" })
          .data()
          .reduce(function (a, b) {
            return intVal(a) + intVal(b);
          }, 0);
        var pageTotal10 = api
          .column("totalchats:name", { page: "current", order: "current" })
          .data()
          .reduce(function (a, b) {
            return intVal(a) + intVal(b);
          }, 0);
        var pageTotal12 = api
          .column("totalleads:name", { page: "current", order: "current" })
          .data()
          .reduce(function (a, b) {
            return intVal(a) + intVal(b);
          }, 0);
        // Update footer

        $(api.column("totalvisitors:name").footer()).html(
          "" + pageTotal2 //+' </br>( '+ total2 +' Total)'
        );
        $(api.column("newvisitors:name").footer()).html(
          "" + pageTotal4 //+' </br>( '+ total4 +' Total)'
        );
        $(api.column("returningvisitors:name").footer()).html(
          "" + pageTotal6 //+' </br>( '+ total6 +' Total)'
        );
        $(api.column("totalcalls:name").footer()).html(
          "" + pageTotal8 //+' </br>( '+ total8 +' Total)'
        );
        $(api.column("totalchats:name").footer()).html(
          "" + pageTotal10 //+' </br>( '+ total10 +' Total)'
        );
        $(api.column("totalleads:name").footer()).html(
          "" + pageTotal12 //+' </br>( '+ total12 +' Total)'
        );
      },
      destroy: true,
      responsive: false,
      autoWidth: true,
    });

    $("div.headertitle").html(
      "</br></br></br><center><u><b>Dynamic and Paid Campaign Conversion</b></u></center>"
    );
    $("div.footertitle").html("</br></br></br>");

    function toggle_row_drill_data(target) {
      var tr = $(target).closest("tr");
      var row = table.row(tr);
      var row_data = row.data();

      //var replace = /(\w+)-(\w+)/;
      var replace = /-.*/;
      var string = row_data[1];
      var sourcestring = string.replace(replace, "");

      $.ajax({
        type: "GET",
        url: "/realtime_market_drill/" + sourcestring + "/" + row_data[0],
        data: {},
        dataType: "json",
        success: function (data) {
          $(".modal-title").append(
            '<h4 class="text-center">' +
              " Domain: " +
              row_data[0] +
              " and Medium: " +
              row_data[1] +
              "</h4>"
          );

          var landing_domain = $.map(data.realtime_market_drill, function (obj, i) {
            return [obj.landing_domain];
          });
          var source = $.map(data.realtime_market_drill, function (obj, i) {
            return [obj.source];
          });
          var medium = $.map(data.realtime_market_drill, function (obj, i) {
            return [obj.utm_medium];
          });
          var campaign = $.map(data.realtime_market_drill, function (obj, i) {
            return [obj.utm_campaign];
          });
          var content = $.map(data.realtime_market_drill, function (obj, i) {
            return [obj.utm_content];
          });
          var term = $.map(data.realtime_market_drill, function (obj, i) {
            return [obj.utm_term];
          });
          var total = $.map(data.realtime_market_drill, function (obj, i) {
            return [obj.total];
          });
          var newvisitors = $.map(data.realtime_market_drill, function (obj, i) {
            return [obj.new];
          });
          var returning = $.map(data.realtime_market_drill, function (obj, i) {
            return [obj.returning];
          });
          var calls = $.map(data.realtime_market_drill, function (obj, i) {
            return [obj.calls];
          });
          var chats = $.map(data.realtime_market_drill, function (obj, i) {
            return [obj.chats];
          });
          var leads = $.map(data.realtime_market_drill, function (obj, i) {
            return [obj.leads];
          });

          var s1 =
            "<p>" +
            "</p>" +
            '<div class="table-responsive">' +
            '<table class="table table-striped table-hover" width="100%" cellspacing="0">' +
            " <thead>" +
            "  <tr>" +
            '      <th rowspan="1" colspan="1" class="text-center">Source</th>' +
            '      <th rowspan="1" colspan="1" class="text-center">Medium</th>' +
            '      <th rowspan="1" colspan="1" class="text-center">Campaign</th>' +
            '      <th rowspan="1" colspan="1" class="text-center">Content</th>' +
            '      <th rowspan="1" colspan="1" class="text-center">Keyword Typed</th>' +
            '      <th rowspan="1" colspan="1" class="text-center">Total Visitors</th>' +
            '      <th rowspan="1" colspan="1" class="text-center">Total New Visitors</th>' +
            '      <th rowspan="1" colspan="1" class="text-center">Total Returning Visitors</th>' +
            '      <th rowspan="1" colspan="1" class="text-center">Total Calls</th>' +
            '      <th rowspan="1" colspan="1" class="text-center">Total Chats</th>' +
            '      <th rowspan="1" colspan="1" class="text-center">Total Leads</th>' +
            "  </tr>" +
            "</thead>" +
            "<tbody>";

          for (var i = 0; i < landing_domain.length; i++) {
            s1 += "<tr>";

            s1 += '<td style="vertical-align:middle" class="text-center">' + source[i] + "</td>";
            s1 += '<td style="vertical-align:middle" class="text-center">' + medium[i] + "</td>";
            s1 += '<td style="vertical-align:middle" class="text-center">' + campaign[i] + "</td>";
            s1 += '<td style="vertical-align:middle" class="text-center">' + content[i] + "</td>";
            s1 += '<td style="vertical-align:middle" class="text-center">' + term[i] + "</td>";
            s1 += '<td style="vertical-align:middle" class="text-center">' + total[i] + "</td>";
            s1 +=
              '<td style="vertical-align:middle" class="text-center">' + newvisitors[i] + "</td>";
            s1 += '<td style="vertical-align:middle" class="text-center">' + returning[i] + "</td>";
            s1 += '<td style="vertical-align:middle" class="text-center">' + calls[i] + "</td>";
            s1 += '<td style="vertical-align:middle" class="text-center">' + chats[i] + "</td>";
            s1 += '<td style="vertical-align:middle" class="text-center">' + leads[i] + "</td>";

            s1 += "</tr>";
          }

          "  </tbody>" + "</table>" + "</div>";

          $(".modal-body").append(s1);

          $("#drill").modal("show");
        },
      });
    }

    $("#realtime_market_results tr td:not(:first-child)").click(function (e) {
      toggle_row_drill_data(e.currentTarget);
    });
    $(".modal").on("hidden.bs.modal", function () {
      $(".modal-title").html("");
      $(".modal-body").html("");
    });

    return () => {
      table.destroy();
    };
  }, [tableData]);

  return (
    <>
      <div className="table-responsive">
        <table
          ref={tableEl}
          className="table table-striped table-hover"
          width="100%"
          cellSpacing="0"
        >
          <thead>
            <tr>
              <th color="#ffffff" className="text-center">
                Domain
              </th>
              <th className="text-center">Source - Medium</th>
              <th className="text-center">Total Visitors</th>
              <th className="text-center">Total Trend (5 Days)</th>
              <th className="text-center">New Visitors</th>
              <th className="text-center">New Trend (5 Days)</th>
              <th className="text-center">Returning Visitors</th>
              <th className="text-center">Returning Trend (5 Days)</th>
              <th className="text-center">Total Calls</th>
              <th className="text-center">Call Trend (5 Days)</th>
              <th className="text-center">Total Chats</th>
              <th className="text-center">Chat Trend (5 Days)</th>
              <th className="text-center">Total Leads</th>
              <th className="text-center">Lead Trend (5 Days)</th>
            </tr>
          </thead>
          <tfoot>
            <tr>
              <th colSpan={2} style={{ textAlign: "right" }}>
                Totals:
              </th>
              <th colSpan={1} style={{ textAlign: "center" }}></th>
              <th colSpan={1} style={{ textAlign: "center" }}></th>
              <th colSpan={1} style={{ textAlign: "center" }}></th>
              <th colSpan={1} style={{ textAlign: "center" }}></th>
              <th colSpan={1} style={{ textAlign: "center" }}></th>
              <th colSpan={1} style={{ textAlign: "center" }}></th>
              <th colSpan={1} style={{ textAlign: "center" }}></th>
              <th colSpan={1} style={{ textAlign: "center" }}></th>
              <th colSpan={1} style={{ textAlign: "center" }}></th>
              <th colSpan={1} style={{ textAlign: "center" }}></th>
              <th colSpan={1} style={{ textAlign: "center" }}></th>
              <th></th>
            </tr>
          </tfoot>
        </table>
      </div>

      <div className="modal fade" id="drill" role="dialog">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal" aria-hidden="true">
                x
              </button>
              <h3 className="modal-title"></h3>
            </div>
            <div className="modal-body"></div>
            <div className="modal-footer">
              <button type="button" className="btn btn-primary " data-dismiss="modal">
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
